import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

/* ===== Page Wrapper ===== */
export const LoginWrapper = styled("div")(() => ({
  display: "flex",
  height: "100vh",
  width: "100%",
  backgroundColor: "#fff",
}));

/* ===== Left ===== */
export const LoginLeft = styled("div")(() => ({
  width: "40%",
  padding: "48px 64px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export const LogoBox = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 12,
  marginBottom: 32,
}));

export const LoginTitle = styled("h2")(() => ({
  fontSize: 28,
  fontWeight: 700,
  marginBottom: 24,
}));

export const LoginForm = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 16,
}));

export const LoginButton = styled(Button)(() => ({
  marginTop: 16,
  height: 48,
  borderRadius: 8,
  fontWeight: 600,
  backgroundColor: "#0F1E4A",
  "&:hover": {
    backgroundColor: "#162A6A",
  },
}));

export const LoginNote = styled("p")(() => ({
  marginTop: 16,
  fontSize: 13,
  color: "#777",
  lineHeight: 1.6,
}));

/* ===== Right ===== */
export const LoginRight = styled("div")(() => ({
  width: "60%",
  backgroundColor: "#0F1E4A",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
}));

export const RightLogo = styled("div")(() => ({
  width: 140,
  height: 140,
  borderRadius: 24,
  backgroundColor: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const BackgroundIcon = styled("div")(() => ({
  position: "absolute",
  inset: 0,
  opacity: 0.08,
  backgroundImage:
    'url(\'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200"><circle cx="100" cy="100" r="80" fill="white"/></svg>\')',
  backgroundRepeat: "repeat",
}));
